var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "400",
      "title": '新增技术服务工单'
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    }
  }, [_c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "客户",
      "prop": "customer"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchCustomer,
      "loading": _vm.customerLoading,
      "placeholder": "请填写客户名字后选择"
    },
    model: {
      value: _vm.formItem.customer,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "customer", $$v);
      },
      expression: "formItem.customer"
    }
  }, _vm._l(_vm.customerList, function (option) {
    return _c('Option', {
      key: option._id,
      staticStyle: {
        "width": "350px"
      },
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('div', {
    staticClass: "dateTime"
  }, [_c('FormItem', {
    staticStyle: {
      "width": "150px",
      "margin-right": "50px"
    },
    attrs: {
      "label": "日期",
      "prop": "date"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    on: {
      "on-change": _vm.chooseDate
    },
    model: {
      value: _vm.formItem.date,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "date", $$v);
      },
      expression: "formItem.date"
    }
  })], 1), _c('FormItem', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "label": "时间",
      "prop": "time"
    }
  }, [_c('TimePicker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "format": "HH:mm",
      "placeholder": "选择时间"
    },
    on: {
      "on-change": _vm.chooseTime
    },
    model: {
      value: _vm.formItem.time,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "time", $$v);
      },
      expression: "formItem.time"
    }
  })], 1)], 1), _c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "实验内容与需求",
      "prop": "content"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "placeholder": "填写实验内容与需求"
    },
    on: {
      "input": _vm.saveContent
    },
    model: {
      value: _vm.formItem.content,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "content", $$v);
      },
      expression: "formItem.content"
    }
  })], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }